// extracted by mini-css-extract-plugin
module.exports = {"statusLine":"MFEsLayout_statusLine__BpQI1","slowNotice":"MFEsLayout_slowNotice__Y4Lbh","mfeSlot":"MFEsLayout_mfeSlot__F7S6W"};